import { render } from "./Progress.vue?vue&type=template&id=5d95b754"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Progress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d95b754"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d95b754', __exports__)) {
    api.reload('5d95b754', __exports__)
  }
  
  module.hot.accept("./Progress.vue?vue&type=template&id=5d95b754", () => {
    api.rerender('5d95b754', render)
  })

}


export default __exports__